<template>
  <button type="submit" :disabled="disabled" :class="[...classes]">
    <div v-if="loading" class="loading__animation row center">
      <Spinner size="extra-small" />
      <WaitingSteps :step="step" />
    </div>

    <span v-else>{{ t(text) }}</span>
  </button>
</template>

<script>
import { ref, watchEffect } from 'vue'

import Spinner from '@components/loading/Spinner.vue'
import WaitingSteps from './components/WaitingSteps.vue'

export default {
  name: 'Submit',
  components: { Spinner, WaitingSteps },
  props: {
    loading: { type: Boolean, default: false },
    text: { type: String, default: 'Submit' },
    disabled: { type: Boolean, default: false },
    classes: { type: Array, default: [] },
  },
  setup(props) {
    const step = ref(1)
    let intervall = null

    watchEffect(() => {
      if (props.loading) {
        intervall = setInterval(() => {
          if (step.value >= 8) step.value = 0
          step.value += 1
        }, 2500)
      } else {
        clearInterval(intervall)
        step.value = 0
      }
    })

    return {
      step,
    }
  },
}
</script>

<style lang="scss" scoped>
button {
  border: none;
  border-radius: 25px;
  background-color: var(--dark-10);
  color: white;
  text-align: center;
  padding: 0 50px;
  height: 45px;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'Poppins', serif;
  align-items: center;
  justify-content: center;

  &:hover,
  &:active {
    transform: scale(0.98);
  }
}
</style>
